<div>
    <div class="card bg-dark text-white " style="height: max-content;">
      <img class="card-img" loading="lazy" src="./assets/backgroundImg/backgroundImg.jpg" alt="Card image">
      <div class="card-img-overlay" >
        <div class="bg-text">
  
          <h2 class="contextMessage">Check our distributor module</h2>
  
          <p style="text-align: start;
          display: flex;
          justify-content: start;
          width: 100%;
          margin-bottom: 0px;"
          >Follow these steps:</p>
          <ul class="breadcrumb">
            <li>Select country</li>
            <li>India</li>
            <li>Select Platform</li>
            <li>Amazon</li>
            <li>Select Service</li>
            <li>Distributor search</li>
          </ul>
  
          <p>Unlock the full potential of your supply chain with our Distributor & Supplier Network Module. 
             This powerful tool offers an extensive list of suppliers, distributors, and manufacturers, all in one place. 
             Whether you're sourcing new suppliers or managing existing relationships, 
             our module provides detailed insights and easy access to key industry players, 
             helping you streamline operations and make informed decisions with confidence.</p>
        </div>
  
      </div>
  
    </div>
    
  </div>